/**
 * @param {string} key
 * @return {string}
 */
function getSelector(key) {
	return `input[name='${key}'],select[name='${key}'],textarea[name='${key}']`;
}

/**
 * Returns a single input value
 *
 * @param {HTMLElement} container
 * @param {string} field
 * @return {string|null}
 */
function getSingleInputByNameV3(container, field) {
	/** @var {HTMLInputElement} */
	const inputElement = container.querySelector(getSelector(field));

	if (!inputElement) {
		return null;
	}

	// Retrieve input value
	const inputType = inputElement.type;
	let value;

	// Parse based on input type
	if (inputType === 'checkbox') {
		value = inputElement.checked;
	} else if (inputType === 'radio') {
		// Radio type found
		// Get the selected radio
		// This mean it runs once for each radio button, not efficient
		// but lets keep it simple
		const selectedRadio = container.querySelector(`input[name="${field}"]:checked`);
		if (selectedRadio) {
			value = selectedRadio.value
		} else {
			value = null;
		}
	} else {
		// Treat normally
		value = inputElement.value;
	}

	return value;
}

/**
 * Returns a single input element
 *
 * @param {HTMLElement} container
 * @param {string} field
 * @return {HTMLInputElement}
 */
function getSingleInputElementByNameV3(container, field) {
	/** @var {HTMLInputElement} */
	let inputElement = container.querySelector(getSelector(field));

	if (!inputElement) {
		return null;
	}

	// Retrieve input value
	const inputType = inputElement.type;

	// Parse based on input type
	if (inputType === 'radio') {
		// Radio type found, only the checked one, if it exists
		inputElement = container.querySelector(`input[name="${field}"]:checked`);

	}

	return inputElement;
}


export {getSingleInputByNameV3, getSingleInputElementByNameV3}
